<div class="v2-background">
  <div *ngIf="currentUser$ | async">
    <app-v2-navigation-menu></app-v2-navigation-menu>
    <div class="white-border"></div>
  </div>
  <div class="v2-body">
    <router-outlet></router-outlet>
  </div>
</div>